import { WeeklyScheduleInputEntry } from './types';

const DAY_DURATION_MIN = 24 * 60;

export const checkForOverlappingTimePairs = (entry: WeeklyScheduleInputEntry) => {
  for (let i = 0; i < entry.timePairs.length; i += 1) {
    for (let j = i + 1; j < entry.timePairs.length; j += 1) {
      const { startMinutes: startA, endMinutes: endA } = entry.timePairs[i];
      const { startMinutes: startB, endMinutes: endB } = entry.timePairs[j];
      if ((startA === 0 && endA === DAY_DURATION_MIN) || (startB === 0 && endB === DAY_DURATION_MIN)) {
        break;
      }

      if (startA < endB && startB < endA) {
        return true;
      }
    }
  }
  return false;
};
